const SUMMARY_GROUPING_OPTIONS = {
    PROJECT: 'Project',
    EMPLOYEE: 'Employee'
} as const;

type ObjectValues<T> = T[keyof T];

export type SummaryGroupingOptions = ObjectValues<typeof SUMMARY_GROUPING_OPTIONS>;

export const summaryGroupingOptionsList = Object.values(SUMMARY_GROUPING_OPTIONS);